import api from "./api";

// getUFs
export const listUFsGet = async () => {
  const response = await api.get(
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
  );

  return response.data;
};

// getMunicipios
export const listMunicipalities = async (municipalities) => {
  if (municipalities) {
    const muni = municipalities.map((municipality) => municipality.id);
    const reqMuni = muni.toString().replace(/,/g, "|");
    const response = await api.get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${reqMuni}/municipios`
    );

    return response.data;
  }
};

// getBairros
export const listNeighborhoods = async (objParameters) => {
  const cidade = objParameters.map((params) => params.cidade);
  const response = await api.get(
    "insights-p2-:stage/:stage/crm/insights/getBairrosByMunicipio",
    {
      params: { cidade },
    }
  );

  return response.data;
};
